import { render, staticRenderFns } from "./PurchasesDeliveryForm.vue?vue&type=template&id=142aed32"
import script from "./PurchasesDeliveryForm.vue?vue&type=script&lang=js"
export * from "./PurchasesDeliveryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports